module.exports = __webpack_public_path__ + "c4165a14.svg";